export { default, AvailabilityDetailOverlay } from './AvailabilityDetailOverlay';



// WEBPACK FOOTER //
// ./app/components/shared/AvailabilityDetailOverlay/index.js